import moment from "moment";

const formatDate = (date: Date) => {
    return moment(date).format('DD/MM/YYYY à HH[h]mm');
}

export default formatDate;